"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Float = exports.List = exports.Dict = void 0;
/**
 * Created by wangtong on 2021/1/4
 */
var convert_1 = require("./convert");
var internal_1 = require("./internal");
var Dict;
(function (Dict) {
    function equal(dict1, dict2) {
        return JSON.stringify(dict1) === JSON.stringify(dict2);
    }
    Dict.equal = equal;
    function copy(dict) {
        return JSON.parse(JSON.stringify(dict));
    }
    Dict.copy = copy;
    /**
     * 遍历字典
     * @param dict
     * @param forEachFunc
     *  function (key, value, index)
     */
    function forEach(dict, forEachFunc) {
        var index = -1;
        for (var key in dict) {
            if (!dict.hasOwnProperty(key)) {
                continue;
            }
            index += 1;
            var value = dict[key];
            forEachFunc(key, value, index);
        }
    }
    Dict.forEach = forEach;
    /**
     * 过滤字典
     * @param dict: 字典
     * @param filterFunc
     *  function (key, value, index):isSave
     *  isSave: bool 是否保存
     * @returns Dict
     */
    function filter(dict, filterFunc) {
        var new_dict = {};
        var index = -1;
        for (var key in dict) {
            if (!dict.hasOwnProperty(key)) {
                continue;
            }
            index += 1;
            var value = dict[key];
            var isSave = filterFunc(key, value, index);
            if (isSave) {
                new_dict[key] = value;
            }
        }
        return new_dict;
    }
    Dict.filter = filter;
    /**
     * 将字典映射为新的字典，只改变value，不改变key
     * @param dict
     * @param mapFunc
     *  mapFunc(key, value, index) => new_value
     */
    function map(dict, mapFunc) {
        var new_dict = {};
        var index = -1;
        for (var key in dict) {
            if (!dict.hasOwnProperty(key)) {
                continue;
            }
            index += 1;
            var value = dict[key];
            new_dict[key] = mapFunc(key, value, index);
        }
        return new_dict;
    }
    Dict.map = map;
    /**
     * 将字典映射为新的字典，同时会改变key和value
     * @param dict
     * @param mapFunc
     *  mapFunc(key, value, index) => {key, value}
     */
    function mapKeyValue(dict, mapFunc) {
        var new_dict = {};
        var index = -1;
        for (var key in dict) {
            if (!dict.hasOwnProperty(key)) {
                continue;
            }
            index += 1;
            var value = dict[key];
            var key_value = mapFunc(key, value, index);
            new_dict[key_value.key] = key_value.value;
        }
        return new_dict;
    }
    Dict.mapKeyValue = mapKeyValue;
    function toList() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var list = [];
        var dict = {};
        var map_func = null;
        switch (args.length) {
            case 1:
                dict = args[0];
                break;
            case 2:
                dict = args[0];
                map_func = args[1];
                break;
        }
        for (var key in dict) {
            if (dict.hasOwnProperty(key)) {
                if (map_func) {
                    list.push(map_func(key, dict[key]));
                }
                else {
                    list.push(dict[key]);
                }
            }
        }
        return list;
    }
    Dict.toList = toList;
    // 将字典变成列表，同时携带字典的键
    function toListWithKey(dict) {
        var list = [];
        for (var k in dict) {
            if (dict.hasOwnProperty(k)) {
                list.push({
                    key: k,
                    value: dict[k]
                });
            }
        }
        return list;
    }
    Dict.toListWithKey = toListWithKey;
    /**
     * 获取字典的第一个键
     * @param dict
     */
    function firstKey(dict) {
        if (!dict) {
            return null;
        }
        for (var key in dict) {
            if (dict.hasOwnProperty(key)) {
                return key;
            }
        }
        return null;
    }
    Dict.firstKey = firstKey;
    /**
     * 获取字典的第一个值
     * @param dict
     */
    function firstValue(dict) {
        if (!dict) {
            return null;
        }
        var key = Dict.firstKey(dict);
        if (key) {
            return dict[key];
        }
        else {
            return null;
        }
    }
    Dict.firstValue = firstValue;
    // 字典赋值
    function assign(target, payload, default_dict) {
        if (payload) {
            for (var key in payload) {
                if (payload[key] !== undefined) {
                    target[key] = payload[key];
                }
            }
            if (default_dict) {
                for (var key in default_dict) {
                    if (default_dict[key] !== undefined && internal_1.isEmpty(target[key])) {
                        target[key] = default_dict[key];
                    }
                }
            }
        }
    }
    Dict.assign = assign;
    function merge(target, payload, default_dict) {
        assign(target, payload, default_dict);
        return target;
    }
    Dict.merge = merge;
    // 以source为基准，只保留value中与source不同的数据
    function diff(source, value) {
        var result = {};
        for (var key in source) {
            if (value[key] !== source[key]) {
                result[key] = value[key];
            }
        }
        return result;
    }
    Dict.diff = diff;
})(Dict || (Dict = {}));
exports.Dict = Dict;
var List;
(function (List) {
    function distinct() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 1) {
            var list = args[0];
            if (list.length > 0) {
                var first_item = list[0];
                switch (typeof first_item) {
                    case "string":
                        return Array.from(new Set(list));
                    case "number":
                        return Array.from(new Set(list));
                    case "object":
                        return List.distinct(list, "id");
                    default:
                        return [];
                }
            }
            else {
                return list;
            }
        }
        else {
            var set_1 = new Set();
            var res_1 = [];
            var list = args[0];
            var primary_key_1 = args[1];
            list.forEach(function (value) {
                var primary_value = internal_1.getPrimaryValue(value, primary_key_1);
                if (!set_1.has(primary_value)) {
                    res_1.push(value);
                    set_1.add(primary_value);
                }
            });
            return res_1;
        }
    }
    List.distinct = distinct;
    function toDict() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 1) {
            return List.toDict(args[0], "id");
        }
        else {
            var dict_1 = {};
            var list = args[0];
            var primary_key_2 = args[1];
            list.forEach(function (value) {
                dict_1[internal_1.getPrimaryValue(value, primary_key_2)] = value;
            });
            return dict_1;
        }
    }
    List.toDict = toDict;
    function toDictIndex() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 1) {
            return List.toDictIndex(args[0], "id");
        }
        else {
            var list = args[0];
            var primary_key_3 = args[1];
            var dict_2 = {};
            list.forEach(function (value, index) {
                dict_2[internal_1.getPrimaryValue(value, primary_key_3)] = index;
            });
            return dict_2;
        }
    }
    List.toDictIndex = toDictIndex;
    function keys() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 1) {
            return List.keys(args[0], "id");
        }
        else {
            var keys_1 = [];
            var list = args[0];
            var primary_key_4 = args[1];
            list.forEach(function (value) {
                keys_1.push(internal_1.getPrimaryValue(value, primary_key_4));
            });
            return keys_1;
        }
    }
    List.keys = keys;
    function range() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var start = 0;
        var end = 0;
        var step = 1;
        switch (args.length) {
            case 1:
                end = args[0];
                break;
            case 2:
                start = args[0];
                end = args[1];
                break;
            case 3:
                start = args[0];
                end = args[1];
                step = args[2];
                break;
        }
        var array = [];
        for (var i = start; i < end; i += step) {
            array.push(i);
        }
        return array;
    }
    List.range = range;
})(List || (List = {}));
exports.List = List;
var Float;
(function (Float) {
    function from(v) {
        return convert_1.Convert.parseFloat(v);
    }
    Float.from = from;
    function format(value, max_fixed) {
        if (max_fixed === void 0) { max_fixed = 2; }
        var str = value.toString();
        var sp = str.split('.');
        if (sp.length > 1 && sp[1].length > max_fixed) {
            str = value.toFixed(max_fixed).toString();
        }
        return str;
    }
    Float.format = format;
    function formatPercent(value) {
        // value是0-1之间的浮点数，将其格式化为百分比打印
        return Float.format(value * 100, 2) + "%";
    }
    Float.formatPercent = formatPercent;
})(Float || (Float = {}));
exports.Float = Float;
//# sourceMappingURL=container.js.map